export enum SmtpSettingsApiKey {
  Server = "Smtp.Server",
  Port = "Smtp.Port",
  From = "Smtp.From",
  FromDisplayName = "Smtp.FromDisplayName",
  Username = "Smtp.Username",
  Password = "Smtp.Password",
  SecureConnection = "Smtp.SecureConnection",
}

export enum GenericSettingsApiKey {
  CategoryAiSearchEnabled = "AIIntegration.CategoryAiSearchEnabled",
}

export interface SystemSettings {
  smtpSettings: SmtpSettings;
  genericSettings: GenericSettings;
}

export interface SmtpSettings {
  server: string;
  port: number;
  from: string;
  fromDisplayName: string;
  username: string;
  password: string;
  secureConnection: boolean;
}

export interface GenericSettings {
  categoryAiSearchEnabled: boolean;
}
